import React from 'react';
import { Link } from 'react-router-dom';
import styles from './header.module.css';

const Header: React.FC = () => {
  return (
    <header className={styles.header}>
      <div className={styles.logo}>
        <Link to="/" className={styles.homeLink}>DSA Visualizer</Link>
      </div>
      <nav className={styles.nav}>
          <Link to="/intro" className={styles.navLink}>Introduction</Link>
          <Link to="/search" className={styles.navLink}>Search</Link>
          <Link to="/sort" className={styles.navLink}>Sorting</Link>
          <Link to="/lists" className={styles.navLink}>Lists</Link>   
          <Link to="/recursion" className={styles.navLink}>Recursion</Link>       
          <Link to="/trees" className={styles.navLink}>Trees</Link>
          <Link to="/advancetrees" className={styles.navLink}>Advance Trees</Link>
          <Link to="/graph" className={styles.navLink}>Graphs</Link>
          <Link to="/map" className={styles.navLink}>Maps</Link>
        {/* Add more categories here as you build them */}
      </nav>
    </header>
  );
};

export default Header;